import client from './client';

export const createFile = files => {
	const formData = new FormData();

	Array.from(files).forEach(file => {
		formData.append('files', file);
	});

	return client.post('/telemedicine/files', formData, {
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	});
};

export const listFiles = ({ patientId, roomId }) => client({
	method: 'get',
	url: '/telemedicine/files',
	params: { patient_id: patientId, room_id: roomId }
});

export const removeFile = id => client({
	method: 'delete',
	url: `/telemedicine/files/${id}`
});
